import general from './general';
import user from './user';

export default {
	general,
	user,
};
